import React, { Component } from 'react'
import { Grid, Row, Col, Glyphicon } from 'react-bootstrap'
import { connect } from 'react-redux'

import { fetchCollection, fetchData } from '../../common/redux/collectionActions'
import QueryWatches from './QueryWatches/QueryWatches'
import DeliverySearch from './DeliverySearch/DeliverySearch'
import AntiChurn from './AntiChurn/AntiChurn'
import Vendors from './Vendors/Vendors'
import Carriers from './Carriers/Carriers'
import Sesam from './Sesam/Sesam'
import Onboarding from './Onboarding/Onboarding'
import DeliveryAdministration from './DeliveryAdministration/DeliveryAdministration'
import HelpTools from './HelpTools/HelpTools'
import Tracking from './Tracking/Tracking'
import ReplacementBench from './ReplacementBench'
import Support from './Support/Support'

// glyphs:
// https://getbootstrap.com/docs/3.3/components/

const menuButtons = [
  { label: 'Sök leverans', glyph: 'glyphicon glyphicon-search', value: 'deliverysearch' },
  { label: 'Leveranser', glyph: 'glyphicon glyphicon-cog', value: 'deliveryadministration' },
  { label: 'Support', glyph: 'glyphicon glyphicon-question-sign', value: 'support' },
  { label: 'Anti Churn', glyph: 'glyphicon glyphicon-fire', value: 'antichurn' },
  { label: 'Leverantörer', glyph: 'glyphicon glyphicon-gift', value: 'vendors' },
  { label: 'Transportörer', glyph: 'glyphicon glyphicon-bullhorn', value: 'carriers' },
  { label: 'Sesam', glyph: 'glyphicon glyphicon-compressed', value: 'sesam' },
  { label: 'Onboarding', glyph: 'glyphicon glyphicon-time', value: 'onboarding' },
  { label: 'Hjälpverktyg', glyph: 'glyphicon glyphicon-scissors', value: 'helptools' },
  { label: 'Tracking', glyph: 'glyphicon glyphicon-stats', value: 'tracking' },
  { label: 'Avbytarbänken', glyph: 'glyphicon glyphicon-pause', value: 'replacement-bench' },
]

class DataAnalyticsContainer extends Component {
  constructor(p) {
    super(p)

    this.state = { passwordHash: '' }

    this.generateMenubar = this.generateMenubar.bind(this)
    this.renderContainer = this.renderContainer.bind(this)
  }

  componentDidMount() {
    const { tabName } = this.props.match.params
    if (tabName !== undefined) {
      this.setState({ selectedContainer: tabName })
    }

    if (!this.props.admin) this.props.fetchCollection('admin')
    this.props.fetchData(['carriers', 'locks', 'customers', 'vendors'])
  }

  getMenuItems = () => {
    const { hidden_subroles } = this.props.admin.user

    const items = menuButtons.filter((btn) => {
      if (hidden_subroles && hidden_subroles.length && hidden_subroles.indexOf(`dataanalytics.${btn.value}`) !== -1) return false

      return true
    })

    return items
  }

  generateMenubar() {
    const divWidth = { width: `${100 / menuButtons.length}%` }

    const bar = this.getMenuItems().map((btn) => {
      const isActive = this.props.history.location.pathname.includes(btn.value)

      return (
        <div key={btn.value} className="DataAnalyticsMenubar" style={{ ...divWidth, color: isActive ? 'white' : 'black', background: isActive ? '#006e78' : 'white' }} onClick={() => this.props.history.push(`/data-analytics/${btn.value}`)}>
          <Glyphicon glyph={btn.glyph}></Glyphicon> {btn.label}
        </div>
      )
    })

    return bar
  }

  renderContainer() {
    const { history } = this.props
    const subPaths = history.location.pathname.split('/').slice(2, 100)

    const carriers = this.props.carriers || []
    const keyedCarriers = carriers.reduce((acc, val) => {
      acc[val._id] = val
      return acc
    }, {})

    switch (subPaths[0]) {
      case 'deliverysearch':
        return <DeliverySearch carriers={keyedCarriers} />
      case 'querywatches':
        return <QueryWatches keyedCarriers={keyedCarriers} />
      case 'antichurn':
        return <AntiChurn />
      case 'vendors':
        return <Vendors />
      case 'carriers':
        return <Carriers />
      case 'support':
        return <Support history={history} />
      case 'sesam':
        return <Sesam />
      case 'deliveryadministration':
        return <DeliveryAdministration />
      case 'onboarding':
        return <Onboarding />
      case 'helptools':
        return <HelpTools />
      case 'tracking':
        return <Tracking />
      case 'replacement-bench':
        return <ReplacementBench />
    }
  }

  render() {
    return (
      <div>
        <div style={{ display: 'flex', marginBottom: 35 }}>{this.props.admin ? this.generateMenubar() : null}</div>

        <Grid fluid>
          <Row>
            <Col xs={12} md={12} lg={12}>
              {this.props.admin ? this.renderContainer() : null}
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

const mapProps = (state) => ({
  admin: state.collectionData.admin,
  carriers: state.collectionData.carriers,
})

const mapDispatch = (dispatch) => ({
  fetchCollection: (...args) => dispatch(fetchCollection(...args)),
  fetchData: (...args) => dispatch(fetchData(...args)),
})

export default connect(mapProps, mapDispatch)(DataAnalyticsContainer)
